import React, { useEffect, useState } from 'react';
import { iconClasses } from '../constants/icons';

const defaultData = { linkType: "", icon: "", text: "" };

export const LinkCard = ({ link }) => {
  const [linkData, setLinkData] = useState(defaultData);

  useEffect(() => {
    const matchedData = iconClasses.find(item => item.linkType === link.type);
    setLinkData(matchedData || defaultData); 
  }, [link]);

  return (
    <div className="link-card">
      <a href={link.url} target="_blank" rel="noreferrer">
        <i className={linkData.icon}></i>
        <span>{link.name || linkData.text}</span>
        <i className="fa-solid fa-angle-right arrow-icon"></i>
      </a>
    </div>
  );
};